import {Component, forwardRef, Input, OnDestroy, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {SubscribedComponent} from "../../subscribed.component";
import {NbComponentOrCustomStatus, NbComponentSize, NbComponentShape, NbFormControlState} from "@nebular/theme";

@Component({
    selector: 'bst-scale-editor',
    templateUrl: './scale-editor.component.html',
    styleUrls: ['./scale-editor.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ScaleEditorComponent),
            multi: true
        }
    ],
    standalone: false
})
export class ScaleEditorComponent extends SubscribedComponent implements
  ControlValueAccessor, OnDestroy {

  static GCOUNTER = 0;

  value: number = null;
  disabled: boolean = false;
  name: string = 'group_' + (ScaleEditorComponent.GCOUNTER++);

  // Function to call when the value changes.
  onChange = (value: number) => {};
  // Function to call when the input is touched (when a star is clicked).
  onTouched = () => {};

  @Input() steps: number = 5;
  @Input() lefttext: string = 'Less';
  @Input() righttext: string = 'More';
  @Input() fullWidth: boolean = false;
  @Input() status: NbComponentOrCustomStatus = 'basic';

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(value: number): void {
    this.value = typeof value !== 'undefined' && value !== null ? value : null;
    this.onChange(this.value);
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  setValue(value: number) {
    this.value = value;
    this.onChange(this.value);
  }
}
